/* eslint-disable react/jsx-indent-props */
import React from 'react';
import {
    AndroidLogo,
    AndroidBackArrow,
    Wrapper,
    Link,
    SubscriptionWrapper
} from './style/MainBlock.styled';
import DescktopLogo from './Components/DescktopLogo';
import Description from './Components/Description';
import Subscription from './Components/Subscription';
import { MainMenu } from '../MainMenu';
import { ContentSection } from '../ContentSection';

// const subscriptions = [
//     {
//         title: 'Подписка на месяц',
//         adv: ['Первый месяц за 1 рубль', 'Отключение рекламы'],
//         type: 'zaycev__month',
//         price: 99,
//         period: 'месяц'
//     },
//     {
//         title: 'Подписка на год',
//         adv: ['Отключение рекламы', 'Самая выгодная подписка'],
//         type: 'zaycev__year',
//         price: 990,
//         period: 'год'
//     }
// ];
const MainBlock = () => {
    return (
        <Wrapper>
            <MainMenu />
            <ContentSection />
            {/* <Link href="https://zaycev.net">
                <AndroidBackArrow src="/assets/back-icon.svg" />
            </Link>
            <AndroidLogo src="/assets/android.svg" />

            <DescktopLogo />
            <Description>
                <SubscriptionWrapper>
                    {subscriptions.map((item) => (
                        <Subscription
                            key={item.type}
                            title={item.title}
                            adv={item.adv}
                            type={item.type}
                            price={item.price}
                            period={item.period}
                        />
                    ))}
                </SubscriptionWrapper>
            </Description> */}
        </Wrapper>
    );
};

export default MainBlock;
